import LANGUAGE from "./language"
import FEEDBACK from "./feedback"
function Banner({handleLanguage,language,direction,currency}) {
    
    return (
        <>
            <LANGUAGE handleLanguage={handleLanguage} language={language}/>
            {currency[0] === "SAR" ? (<FEEDBACK language={language} direction={direction}/>):('')}
            <div className="image-container" dir={direction}>
                <img src="../assets/logo.png" className="logo-image" alt="Overlay" />
            </div>
        </>
    );
}

export default Banner;